import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Box, Paper, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import walletApi from '../api/wallet';
import { getErrorMessage } from '../utils/errors';
import GoogleLoginButton from './auth/GoogleLoginButton';
import { setAccessToken } from '../utils/accessToken';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const isGoogleLoginEnabled = process.env.NODE_ENV !== 'production'
    || Boolean(process.env.REACT_APP_GOOGLE_CLIENT_ID);

  const handleAuthSuccess = (response) => {
    const { Token, User } = response.data;
    setAccessToken(Token);
    localStorage.setItem('user', JSON.stringify(User));
    navigate('/home');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    walletApi.post('/user/login', {
      Email: email,
      Password: password,
    }, { withCredentials: true }).then((response) => {
      handleAuthSuccess(response);
    }
    ).catch((error) => {
      setError(getErrorMessage(error, 'Erro ao fazer login. Verifique suas credenciais e tente novamente.'));
    })
  };

  const handleGoogleSuccess = (idToken) => {
    walletApi.post('/user/login/google', {
      id_token: idToken,
    }, { withCredentials: true }).then((response) => {
      handleAuthSuccess(response);
    }).catch((error) => {
      setError(getErrorMessage(error, 'Erro ao fazer login com Google. Tente novamente.'));
    });
  };

  const handleGoogleError = (message) => {
    setError(message);
  };

  const handleCreateAccount = () => {
    navigate('/user/register');
  };
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #0d47a1 0%, #512da8 100%)',
      }}
    >
      <Container maxWidth="xs">
        <Paper elevation={8} sx={{ p: 4, borderRadius: 3 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Bem-vindo
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Acesse sua carteira para continuar
            </Typography>
          </Box>
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label="Email"
              variant="outlined"
              margin="normal"
              fullWidth
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              label="Password"
              type="password"
              variant="outlined"
              margin="normal"
              fullWidth
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {error}
              </Typography>
            )}
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
              Entrar
            </Button>
            <Divider sx={{ my: 3 }}>ou</Divider>
            {isGoogleLoginEnabled ? (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <GoogleLoginButton onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary" align="center">
                Login com Google indisponível no momento
              </Typography>
            )}
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={handleCreateAccount}
              sx={{ mt: 3 }}
            >
              Criar Conta
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login;